// extracted by mini-css-extract-plugin
module.exports = {"guide":"PaperB_guide__3mtSS","intro":"PaperB_intro__1dkjj","intro_1":"PaperB_intro_1__2XKre"};